import React, { useRef, useState } from "react";
import api from "@/lib/api";
import { Volume2, Loader2 } from "lucide-react";

const cache = new Map();

export default function AudioButton({ text, voice = "child", label = "Play", className = "", testId = "audio-btn" }) {
  const [loading, setLoading] = useState(false);
  const audioRef = useRef(null);

  const play = async () => {
    if (!text) return;
    try {
      setLoading(true);
      const key = `${voice}::${text}`;
      let url = cache.get(key);
      if (!url) {
        const { data } = await api.post("/tts/generate", { text, voice });
        url = data.audio_url;
        cache.set(key, url);
      }
      if (audioRef.current) {
        audioRef.current.src = url;
        await audioRef.current.play();
      }
    } catch (e) {
      // graceful fallback to Web Speech API for upstream/voice failures (e.g., 502)
      try {
        window.speechSynthesis?.cancel?.();
        const u = new SpeechSynthesisUtterance(text);
        u.rate = 0.95; u.pitch = voice === "child" ? 1.3 : 1.0;
        window.speechSynthesis.speak(u);
      } catch {}
    } finally { setLoading(false); }
  };

  return (
    <>
      <button onClick={play} data-testid={testId}
        className={`inline-flex items-center gap-2 rounded-full bg-white border-2 border-sky-200 px-4 py-2 text-sky-700 font-semibold shadow-sm hover:bg-sky-50 transition ${className}`}>
        {loading ? <Loader2 className="w-5 h-5 animate-spin"/> : <Volume2 className="w-5 h-5"/>}
        <span>{label}</span>
      </button>
      <audio ref={audioRef} className="hidden"/>
    </>
  );
}
